<div class="gamedata-compare-tool">
  <h2>GameData Compare Tool</h2>
  <p class="description">
    Upload two GameData SQLite files to see a table-by-table diff (added, removed, and modified rows with field-level changes).
    Results are shown on the next page. Access is restricted to users with gamedata permissions.
  </p>

  <div class="upload-section">
    <div class="file-row">
      <label>
        <span class="label">File A (e.g. previous build)</span>
        <input type="file" accept=".sqlite,.db" (change)="onFileAChange($event)" />
        <span class="file-name">{{ fileA?.name || 'No file chosen' }}</span>
      </label>
    </div>
    <div class="file-row">
      <label>
        <span class="label">File B (e.g. new build)</span>
        <input type="file" accept=".sqlite,.db" (change)="onFileBChange($event)" />
        <span class="file-name">{{ fileB?.name || 'No file chosen' }}</span>
      </label>
    </div>

    <div class="actions">
      <button pButton type="button" label="Compare" icon="pi pi-refresh" [loading]="isUploading" [disabled]="!fileA || !fileB || isUploading" (click)="submit()"></button>
      <button pButton type="button" label="Clear" class="p-button-secondary" [disabled]="isUploading" (click)="clearFiles()"></button>
    </div>

    <div *ngIf="errorMessage" class="error-message">
      {{ errorMessage }}
    </div>
  </div>

  <div class="help">
    <h3>How to use</h3>
    <ul>
      <li>Choose two <strong>.sqlite</strong> GameData files (e.g. from different builds or environments).</li>
      <li>Click <strong>Compare</strong>. The tool will generate a diff and open the results page.</li>
      <li>On the results page, expand each table to see added rows, removed rows, and modified rows with field-level changes.</li>
      <li>Large tables are capped (e.g. first 500 added/removed/updated rows) for performance.</li>
    </ul>
    <p>For more details, see <strong>docs/GAMEDATA_COMPARE_TOOL.md</strong>.</p>
  </div>
</div>
